import { getPreviousDate, getYear, getQuarter, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { marketAnalyzerEvolutionSkuCurrentPeriod, marketAnalyzerEndDate } from "../../@signals"


export const rangeDatesPricingMarketSku = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, marketAnalyzerEndDate.value), getPreviousDate({ days: 1 }, marketAnalyzerEndDate.value)] },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 6 }), stringToDate(marketAnalyzerEndDate.value)] },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 29 }), stringToDate(marketAnalyzerEndDate.value)] },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last 60 Days',
        value: () => { return [getPreviousDate({ days: 59 }), stringToDate(marketAnalyzerEndDate.value)] },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_60_DAYS
    }, {
        label: 'Last 90 Days',
        value: () => { return [getPreviousDate({ days: 89 }), stringToDate(marketAnalyzerEndDate.value)] },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_90_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(marketAnalyzerEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(marketAnalyzerEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }, {
        label: 'Last Quarter',
        value: () => {
            const endDate = stringToDate(marketAnalyzerEndDate.value)
            const currentYear = getYear(endDate)
            const currentQuarter = getQuarter(endDate)

            const lastQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1
            const lastQuarterMonth = lastQuarter * 3
            const lastQuarterYear = currentQuarter === 1 ? currentYear - 1 : currentYear

            return [new Date(lastQuarterYear, lastQuarterMonth - 3, 1), new Date(lastQuarterYear, lastQuarterMonth, 0)]
        },
        placement: 'left',
        onFocus: () => marketAnalyzerEvolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_QUARTER
    }
]